import { OpcionDeGasto, TerceroDelGasto } from '../../services/expense.service';

/**
 * B9.5 · caja menor con categoría y proveedor (-mt V210; textos de Producto, TEXTOS 448ae00). Las dos listas son
 * opcionales: una que no cargó o que vino vacía no se pinta, y el gasto se registra como siempre.
 */
export const TEXTOS_DEL_GASTO = {
    categoria: 'Categoría (opcional)', sinCategoria: 'Sin categoría',
    proveedor: 'Proveedor (opcional)', sinProveedor: 'Sin proveedor',
};

/** Los nombres los escribe el comercio y van dentro del `html` de SweetAlert: se escapan. */
function escapar(texto: string): string {
    return texto.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}

function lista(id: string, etiqueta: string, vacia: string, opciones: OpcionDeGasto[]): string {
    if (opciones.length === 0) return '';
    const items = opciones.map(o => `<option value="${o.id}">${escapar(o.nombre)}</option>`).join('');
    return `<label for="${id}" class="swal2-input-label">${etiqueta}</label>`
        + `<select id="${id}" class="swal2-select"><option value="">${vacia}</option>${items}</select>`;
}

export function htmlDeListas(categorias: OpcionDeGasto[], proveedores: OpcionDeGasto[]): string {
    const t = TEXTOS_DEL_GASTO;
    return lista('e-categoria', t.categoria, t.sinCategoria, categorias) + lista('e-proveedor', t.proveedor, t.sinProveedor, proveedores);
}

/** Lo elegido → ids; sin lista o con la opción vacía, nada (no viaja la clave). */
export function terceroElegido(leer: (id: string) => string | null): TerceroDelGasto {
    const id = (v: string | null) => (v && /^\d+$/.test(v) ? Number(v) : null);
    const categoryId = id(leer('e-categoria'));
    const supplierId = id(leer('e-proveedor'));
    return { ...(categoryId != null ? { categoryId } : {}), ...(supplierId != null ? { supplierId } : {}) };
}
